import { ExternalLink } from "lucide-react";

import { Button } from "../../../button";

interface PdfControlsProps {
  blobUrl: string | null;
  onOpenInNewTab: () => void;
}

export const PdfControls = ({ blobUrl, onOpenInNewTab }: PdfControlsProps) => (
  <div className="flex items-center justify-between">
    <div className="text-sm font-medium">PDF Preview</div>
    <Button variant="outline" size="sm" onClick={onOpenInNewTab} disabled={!blobUrl}>
      <ExternalLink className="mr-1 h-3 w-3" />
      Open
    </Button>
  </div>
);
